import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/help-center-tabs.css";

const translations = {
    vi: {
        loading: "Đang tải danh sách bài viết...",
        loadMore: "Xem thêm",
    },
    en: {
        loading: "Loading help articles...",
        loadMore: "Load More",
    },
    ko: {
        loading: "도움말 문서를 불러오는 중입니다...",
        loadMore: "더 보기",
    }
};

function HelpCenter({ lang = "vi" }) {
    const history = useHistory();
    const t = translations[lang] || translations.vi;

    const [grouped, setGrouped] = useState({});
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("");
    const [visibleCount, setVisibleCount] = useState(5);

    const handleTabChange = (category) => {
        setActiveTab(category);
        setVisibleCount(5);
    };

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;
        if (newLang === 'vi') history.push('/help-center');
        else history.push(`/${newLang}/help-center`);
    };

    useEffect(() => {
        setLoading(true);
        fetch("https://blog.hanbiro.vn/?rest_route=/help-system/v1/mappings")
            .then((res) => res.json())
            .then((res) => {
                if (Array.isArray(res)) {
                   groupByCategory(res);
                } else if (res.success && res.mappings) {
                    groupByCategory(res.mappings);
                }
            })
            .catch((err) => console.error("API error:", err))
            .finally(() => setLoading(false));
    }, []);

    const groupByCategory = (items) => {
        const groupedData = {};

        items.forEach((item) => {
            if (!groupedData[item.category]) {
                groupedData[item.category] = [];
            }
            groupedData[item.category].push(item);
        });

        setGrouped(groupedData);

        const firstCategory = Object.keys(groupedData)[0];
        if (firstCategory) {
            setActiveTab(firstCategory);
        }
    };

    const navigateToArticle = (postId) => {
        if (lang === 'vi') history.push(`/help-article/${postId}`);
        else history.push(`/${lang}/help-article/${postId}`);
    };

    if (loading) {
        return (
            <div className="container my-5 text-center">
                <div className="article-loading">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">{t.loading}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-5">
            {/* ===== DROPDOWN LANGUAGES ===== */}
            <div className="language-select" style={{ textAlign: 'right', marginBottom: '1rem' }}>
                <select 
                    name="language" 
                    id="language-select" 
                    value={lang} 
                    onChange={handleLanguageChange}
                    style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc' }}
                >
                    <option value="vi">Vietnamese</option>
                    <option value="en">English</option>
                    <option value="ko">Korean</option>
                </select>
            </div>

            {/* ===== TAB NAVIGATION ===== */}
            <div className="tab-navigation mb-4">
                {Object.keys(grouped).map((category) => (
                    <button key={category} className={`tab-button-help-center ${activeTab === category ? "active" : ""}`} onClick={() => handleTabChange(category)}>
                        {category}
                    </button>
                ))}
            </div>

            {/* ===== TAB CONTENT ===== */}
            <div className="tab-content">
                {activeTab && grouped[activeTab] && (
                    <div className="tab-pane active">
                        {/* <h3 className="mb-3">{activeTab}</h3> */}
                        <ul className="help-list">
                            {grouped[activeTab]
                            .filter(page => page.lang === lang)
                            .slice(0, visibleCount)
                            .map((page) => (
                                <li key={page.id} onClick={() => navigateToArticle(page.id)} className="help-item">
                                    {page.title}
                                </li>
                            ))}
                        </ul>

                        {/* Button Load More */}
                        {visibleCount < grouped[activeTab].filter(page => page.lang === lang).length && (
                            <div className="text-center mt-3">
                                <button className="btn-more-help-center" onClick={() => setVisibleCount((prev) => prev + 5)} style={{ borderRadius: "20px", padding: "8px 24px" }}>
                                    {t.loadMore}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default HelpCenter;
